export default __webpack_public_path__ + "static/media/hero-bcg.62414bf4.jpg";